"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setHour12(formats, hour12) {
    // Can't rely on hour12 due to this bug in the spec https://github.com/tc39/ecma402/issues/402
    const change = { hour12: undefined, hourCycle: hour12 ? "h12" : "h23" };
    return {
        ...formats,
        date: Object.keys(formats.date).reduce((obj, key) => ({ ...obj, [key]: { ...formats.date[key], ...change } }), {}),
        time: Object.keys(formats.time).reduce((obj, key) => ({ ...obj, [key]: { ...formats.time[key], ...change } }), {}),
    };
}
exports.default = setHour12;
